import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';
import { TNumberInputs } from '../../types/filter';
import { NumberInput } from '../NumberInput';
import * as styles from '../Filters/Filters.css';

interface IAreaInputProps {
  minArea: TNumberInputs;
  maxArea: TNumberInputs;
  error: boolean;
  onChange: (type: 'minArea' | 'maxArea') => (value: number | void) => void;
  onBlur: () => void;
}

export function AreaInput({ minArea, maxArea, error, onChange, onBlur }: IAreaInputProps) {
  return (
    <>
      <InlineText2>Площадь</InlineText2>

      <div className={styles['input__wrapper']}>
        <NumberInput
          leftAdornment="от:"
          rightAdornment={minArea ? 'м²' : undefined}
          value={minArea}
          onChange={onChange('minArea')}
          onBlur={onBlur}
          invalid={error}
          min={0}
          small
        />
        <NumberInput
          leftAdornment="до:"
          rightAdornment={maxArea ? 'м²' : undefined}
          value={maxArea}
          onChange={onChange('maxArea')}
          onBlur={onBlur}
          invalid={error}
          min={0}
          small
        />
      </div>
    </>
  );
}
